import React, { useState, useEffect } from 'react';
import TeachHeader from '../Teacher/TeachHeader'

import { useParams, Link } from 'react-router-dom';
import axios, { decryptData, encryptData } from '../Axiosinstance';
import { Table, TableBody, TableCell, Typography, TableHead, TableRow, TableContainer, Paper, Button, TextField, InputAdornment } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import SearchIcon from '@mui/icons-material/Search';
import * as XLSX from 'xlsx';
import { Link as RouterLink } from 'react-router-dom';
import { buttonBackgroundColor } from '../common';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const App = () => {
  const { batchId } = useParams();
  const [intakeDetails, setIntakeDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchIntakeId = async () => {
      try {
        const response = await axios.get(`/intake-details/batch/${batchId}`);
        setIntakeDetails(response.data);
        console.log("Intakestudentdatails:", response.data)
      } catch (error) {
        console.error("Error fetching batch details:", error);
      }
    };

    if (batchId) {
      fetchIntakeId();
    }
  }, [batchId]);

  // Filter logic
  const filteredData = intakeDetails.filter((intake) =>
    intake.intakeId.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Export to Excel
  const exportToExcel = () => {
    const dataToExport = filteredData.map(({ intakeId, startDate, endDate }) => ({
      "Intake ID": intakeId,
      "Start Date": new Date(startDate).toLocaleDateString("en-GB"),
      "End Date": new Date(endDate).toLocaleDateString("en-GB")
    }));
    const ws = XLSX.utils.json_to_sheet(dataToExport);
    ws['!cols'] = [
      { wch: 12 }, // Intake ID width
      { wch: 15 }, // Start Date width
      { wch: 15 }  // End Date width
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Intake Details");
    XLSX.writeFile(wb, "IntakeDetails.xlsx");
  };


      const theme = useTheme();
      const isLaptop = useMediaQuery('(min-width:600px) and (max-width:1400px)'); console.log('isLaptop', isLaptop)
      // console.log('isLaptop',isLaptop)
      const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <div>
      <TeachHeader />
      <br />
      <div style={{ marginTop: isMobile ? '50px' : isLaptop ? '30px' : '-70px',}}>

      <Typography  style={{ fontWeight: 'bolder' ,marginTop:"-1rem"}} variant="h4" textAlign="center" gutterBottom>
             Intake details
            </Typography>
      <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '90%', margin: '-7px auto' }}>

        {/* Search and Download Button */}
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '98%',
          padding: '10px',
          gap:6,
          background: '#fff',
          boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
        }}>
          <TextField
            label="Search Intake ID"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ flex: 1, minWidth: '250px', marginRight: '10px', background: '#fff' }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <Button variant="contained" color="primary" style={{backgroundColor:buttonBackgroundColor,color:'white'}} onClick={exportToExcel}>Download Excel</Button>
        </div>

        {/* Table with Infinite Scrolling */}
        <div style={{
          height: '400px',
          overflowY: 'auto',
          width: '100%',
        
          padding: '10px',
         
        }}>
          <TableContainer component={Paper} style={{ width: '100%', overflowX: 'auto' }}>
            <Table aria-label="sticky table">
              <TableHead style={{ backgroundColor: 'black', position: 'sticky', top: 0, zIndex: 1 }}>
                <TableRow>
                  <TableCell><strong>Intake ID</strong></TableCell>
                  <TableCell><strong>Start Date</strong></TableCell>

                  <TableCell><strong>End Date</strong></TableCell>
                  <TableCell><strong>Manage</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.length > 0 ? (
                  filteredData.map((intake) => (
                    <TableRow key={intake.id}>
                      <TableCell>{intake.intakeId}</TableCell>
                      <TableCell>{new Date(intake.startDate).toLocaleDateString("en-GB")}</TableCell>
                      <TableCell>{new Date(intake.endDate).toLocaleDateString("en-GB")}</TableCell>
                      <TableCell>
                        <Button
                          component={RouterLink}
                          to={`/Intakestudent/${encodeURIComponent(encryptData(intake.batchId))}/${encodeURIComponent(encryptData(intake.intakeId))}`}
                          variant="contained"
                          size="small"
                          color="primary"
                          style={{backgroundColor:buttonBackgroundColor,color:'white'}}
                        >
                          View Batch
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">No records found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <ToastContainer />
      </div>
</div>
    </div>
  );
};

export default App;
